import style from "../style.module.scss";
import DocumentImage from "assets/document.png";

export const EmptyPage = () => {
  return (
    <div className={style.container}>
      <h5 className="text-center text-light mt-4 p-4">
        Questa cartella è vuota
      </h5>
      <div className="text-center">
        <img alt="Empty Page" src={DocumentImage} width={100} height={120} />
      </div>

      <h5 className="text-center text-light p-4">
        Carica i tuoi file cliccando in alto a destra o trascinandoli qui
      </h5>
    </div>
  );
};
